import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {TranslateModule} from '@ngx-translate/core';
import {ChatbotPopupComponent} from './chatbot-popup/chatbot-popup.component';
import {IChatOpenRequest} from './chatbot.interface';
import {ChatbotService} from './chatbot.service';

@Component({
  selector: 'app-chatbot',
  standalone: true,
  imports: [TooltipModule, TranslateModule, ChatbotPopupComponent],
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.scss'],
})
export class ChatbotComponent implements OnInit {
  popupRequested = false;
  openRequest: IChatOpenRequest | null = null;

  private readonly chatbotService = inject(ChatbotService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.chatbotService.helpCaseOpenRequested
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((helpCase) => this.requestOpen({helpCase}));
  }

  onChatbotClick(): void {
    this.requestOpen({});
  }

  // A new object every time, so the popup reopens even for a repeated request.
  private requestOpen(request: IChatOpenRequest): void {
    this.popupRequested = true;
    this.openRequest = request;
  }
}
